// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	$ = jQuery;

	'use strict';

	var findSvg = jQuery('img.brochure-button-svg, img.plans-button-svg');
	// change svg image hover color
	// to get SVG Code, to set FILL or STROKE States
	findSvg.each(function() {
		// define image element
		var $img = jQuery(this);
		var $imgId = $img.attr('id');
		// get the image source using src attribute
		var imgURL = $img.attr('src');
		var attributes = $img.prop("attributes");
		jQuery.get(imgURL, function(data, status) {
			// Get the SVG tag, ignore the rest
			var $svg = jQuery(data).find('svg');
			// Remove any invalid XML tags
			$svg = $svg.removeAttr('xmlns:a');
			// Loop through IMG attributes and apply on SVG
			jQuery.each(attributes, function() {
				$svg.attr(this.name, this.value);
			});
			// Replace IMG with SVG
			$img.replaceWith($svg);
		}, 'xml');
	});

	// AOS
	AOS.init({
		// Global settings:
		//		disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
		//		startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
		//		initClassName: 'aos-init', // class applied after initialization
		//		animatedClassName: 'aos-animate', // class applied on animation
		//		useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
		//		disableMutationObserver: false, // disables automatic mutations' detections (advanced)
		//		debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
		//		throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)

		// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
		offset: 100, // offset (in px) from the original trigger point
		delay: 0, // values from 0 to 3000, with step 50ms
		duration: 2200, // values from 0 to 3000, with step 50ms
		easing: 'ease', // default easing for AOS animations
		once: false, // whether animation should happen only once - while scrolling down
		//		mirror: false, // whether elements should animate out while scrolling past them
		//		anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
	});

	var videoPopup  = jQuery('.neovideopopup');

	// lightbox video
	videoPopup.magnificPopup({
		type: "iframe",
		closeOnContentClick: false,
		closeBtnInside: false,
		overflowY: "hidden",
		removalDelay: 300,
		midClick: true,
		mainClass: 'mfp-fade',
		iframe: {
			markup: '<div class="mfp-iframe-scaler">' + '<div id="iframe"></div>' + "</div>",
		},
		callbacks: {
			beforeOpen: function() {
//				this.st.iframe.markup = this.st.iframe.markup.replace("mfp-iframe-scaler", "mfp-iframe-scaler mfp-with-anim");
//				this.st.mainClass = this.st.el.attr("data-effect");
			},
		}
	});

	// insert vimeo video with API and autoplay with sound on
	videoPopup.on('click', function(e) {
		e.preventDefault();

		var regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
//		var _href = $(this).attr('href');
		var _href = jQuery(this).attr('data-mfp-src');
		var _vimeoID = _href.match(regExp)[5];

		var options = {
			id: _vimeoID,
//			width: 640,
			loop: true,
			muted: true,
			autoplay: true
		};

		var player = new Vimeo.Player('iframe', options);
		player.setVolume(1);
	});

	function customVideoLazyLoad() {
		var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

		if ("IntersectionObserver" in window) {
			var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
				entries.forEach(function(video) {
					if (video.isIntersecting) {
						for (var source in video.target.children) {
							var videoSource = video.target.children[source];
							if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
								videoSource.src = videoSource.dataset.src;
							}
						}

						video.target.load();
						video.target.classList.remove("lazy");
						lazyVideoObserver.unobserve(video.target);
					}
				});
			});

			lazyVideos.forEach(function(lazyVideo) {
				lazyVideoObserver.observe(lazyVideo);
			});
		}
	}

	function lazyload() {
		$('.neolazy').Lazy({
			scrollDirection: 'vertical',
			effect: 'fadeIn',
			effectTime: 600,
			visibleOnly: true,
			threshold: 800,
			onError: function(element) {
				console.log('error loading ' + element.data('src'));
			},
		});
		customVideoLazyLoad();
	}
	lazyload();

	// Availability section: highlight parts of stack on hover/click
	jQuery('.stack__layer__toggles .layer__toggle').on('mouseenter click', function (){
		var hoveredLevel = jQuery(this).data('level');
		// Toggle buttons
		jQuery(this).siblings('.layer__toggle').removeClass('active');
		jQuery(this).addClass('active');
		// SVG Stack levels
		jQuery('.stack__container svg .stack__level').removeClass('active');
		jQuery('.stack__container svg .stack__level[data-level=' + hoveredLevel + ']').addClass('active');
		// Callout groups
		jQuery('.availability .callouts__container .callouts').removeClass('active');
		jQuery('.availability .callouts__container .callouts[data-level=' + hoveredLevel + ']').addClass('active');
	});

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	// Neoscape remote branding
	(function () { var e = document.createElement("script"); e.src = ("https://www.neoscape.com/_remotebranding/neocredit-1.1.0.min.js"); document.body.appendChild(e); var options = { style: "white", size: "20px", opacity: 1.0 };  })();

} )();